import { Component, Inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

export interface MockTimerExpiredModalData {
  currentSection: number;
  totalSections: number;
}

@Component({
    selector: 'app-mock-timer-expired-modal',
    templateUrl: './mock-timer-expired-modal.component.html',
    styleUrls: ['./mock-timer-expired-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CdkScrollable, MatDialogContent, MatButton]
})
export class MockTimerExpiredModalComponent {

  constructor(
    public dialogRef: MatDialogRef<MockTimerExpiredModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MockTimerExpiredModalData
  ) {  }

  public onReturnToExam(): void {
    this.dialogRef.close('return');
  }

  public onContinue(): void {
    if (this.data.currentSection === 1 && this.data.totalSections === 2) {
      this.dialogRef.close('break'); 
    } else {
      this.dialogRef.close('continue');
    }
  }

  public onEndExam(): void {
    this.dialogRef.close('end');
  }
}
